var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFabButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "url(#paint0_linear_14350_8338)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2772 16H18.7213C17.7702 16 17 16.8511 17 17.9002V33.476C17 34.222 17.3963 34.9004 18.0124 35.2081L27.2739 39.8311C27.7256 40.0563 28.2415 40.0563 28.6932 39.8311L37.9876 35.1916C38.6037 34.8839 39 34.2069 39 33.4595V17.9002C39 16.8511 38.2298 16 37.2787 16H37.2772ZM28.3298 38.4818C28.1249 38.5838 27.8856 38.5838 27.6807 38.4818L18.8424 34.0854C18.5927 33.9608 18.4342 33.7056 18.4342 33.4249V29.2777L32.5964 36.3474L28.3298 38.4803V38.4818ZM37.5643 25.3571L33.531 23.3548V21.9004C33.531 21.6962 33.3665 21.5311 33.1646 21.5311H22.6993C22.5737 21.5311 22.4705 21.6347 22.4705 21.7608V21.7698C22.4705 21.8583 22.5198 21.9379 22.5991 21.9769L37.5643 29.3783V33.2268C37.5643 33.533 37.2787 33.7371 37.026 33.6126L18.4342 24.4641V18.1779C18.4342 17.7712 18.7617 17.4409 19.1655 17.4409H36.8316C37.2353 17.4409 37.5628 17.7712 37.5628 18.1779V25.3571H37.5643Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14350_8338",
    x1: 28,
    y1: 0,
    x2: 28,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C6C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0E798B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BC2A9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFabButton);
export default __webpack_public_path__ + "static/media/FabButton.5d1f5925170ab31038c8cce8f40352cd.svg";
export { ForwardRef as ReactComponent };